/*
 * @Date: 2021-03-15 10:45:54
 * @LastEditors  : zhangxu
 * @LastEditTime : 2021-09-23 16:41:10
 * @FilePath     : /daodao-biz-front/src/store/pageState.ts
 */
import { getOrg, getOrgUser } from '@/request/index'

interface SettingsPageState {
  isUpdateCache?: boolean
}

interface OrgInfoState {
  [props: string]: any
}

interface OrgUserInfoState {
  [props: string]: any
}

interface State {
  settings: SettingsPageState
  orgInfo: OrgInfoState
  orgUserInfo: OrgUserInfoState
}

export default {
  state: {
    settings: {
      isUpdateCache: false,
    },
    orgInfo: {},
    orgUserInfo: {},
  },
  getters: {
    getSettingsCache: (state: State) => state.settings.isUpdateCache,
    getOrgInfo: (state: State) => state.orgInfo,
    getOrgUserInfo: (state: State) => state.orgUserInfo,
  },
  mutations: {
    setSettingsState(state: State, payload: SettingsPageState) {
      state.settings = {
        ...state.settings,
        ...payload,
      }
    },
    setOrgInfo(state: State, payload: OrgInfoState) {
      state.orgInfo = payload
    },
    setOrgUserInfo(state: State, payload: OrgUserInfoState) {
      state.orgUserInfo = payload
    },
  },
  actions: {
    async actGetOrgInfo({ commit }: any) {
      const { org, haveEarlyEduTrack } = await getOrg({
        statistic: true,
      })
      commit('setOrgInfo', { ...org, haveEarlyEduTrack })
    },
    async actGetOrgUserInfo({ commit, rootState }: any) {
      const { user } = await getOrgUser({ userId: rootState.user.user.userId })
      commit('setOrgUserInfo', user)
    },
  },
}
